import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingContainerService {
	@Output() readonly displayLoaderByIdEvent: EventEmitter<string> =
		new EventEmitter();
	@Output() readonly hideLoaderByIdEvent: EventEmitter<string> =
		new EventEmitter();
	@Output() readonly hideLoadersEvent: EventEmitter<any> = new EventEmitter();
	@Output() readonly displayLoaderEvent: EventEmitter<any> = new EventEmitter();

	displayLoaderById(loaderId: string): void {
		this.displayLoaderByIdEvent.emit(loaderId);
	}

	hideLoaderById(loaderId: string): void {
		this.hideLoaderByIdEvent.emit(loaderId);
	}

	hideLoaders(): void {
		this.hideLoadersEvent.emit();
	}

	displayLoader(): void {
		this.displayLoaderEvent.emit();
	}
}
